import React, { Component } from 'react';
import axios from 'axios';
import jwt from 'jsonwebtoken';
import md5 from 'md5';
import 'formdata-polyfill';

import logo from './logo.png';
import './App.css';
import Spinner from './Spinner';

const toBase64 = file => new Promise((resolve, reject) => {
	if ( /\.(jpe?g|png|gif|pdf)$/i.test(file.name) ) {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	} else {
		reject(`Must be correct type: ${file.name}`)
	}
});

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			html: null,
			message: null,
			expiry: null,
			loading: false
		};
	}


	async componentDidMount() {
		const env = `prod`
		try {
			const formRes = await axios({
				method: `POST`,
				url: `https://m570gzyn6h.execute-api.us-east-1.amazonaws.com/${env === `test` ? `staging` : `production`}`,
				data: {
					url: `https://giftwp${env === `test` ? `-test` : ``}.escsportsapi.com/form/load`,
					data: {
						url: `gift.goalsetter.com`,
					}
				},
			})

			this.setState({
				html: formRes.data.form,
				expiry: formRes.data.expiry
			});

// 			let costWrapper = document.querySelector('.gwp-cost-wrapper');
// 			let paymentWrapper = document.querySelector('.payment-wrapper');
// 			let gwpGift = document.querySelector('#gwp-gift');

			// if (paymentWrapper) {
			// 	paymentWrapper.style.display = 'none';
			// 	const paymentInputs = paymentWrapper.querySelectorAll('input, select');

			// 	if (paymentInputs) {
			// 		for (let i = paymentInputs.length; i--;) {
			// 			paymentInputs[i].required = false;
			// 		}
			// 	}

			// 	if (gwpGift) {
			// 		gwpGift.addEventListener('change', () => {
			// 			if (gwpGift.value.toLowerCase().indexOf('custom') !== -1) {
			// 				costWrapper.style.display = 'block';
			// 				paymentWrapper.style.display = 'block';
			// 				for (let i = paymentInputs.length; i--;) {
			// 					paymentInputs[i].required = true;
			// 				}
			// 			} else {
			// 				costWrapper.style.display = 'none';
			// 				paymentWrapper.style.display = 'none';
			// 				for (let i = paymentInputs.length; i--;) {
			// 					paymentInputs[i].required = false;
			// 				}
			// 			}
			// 		});
			// 	}
			// }

			// if (costWrapper) costWrapper.style.display = 'none';


			let form = document.querySelector('form');
			if (form) {
				form.addEventListener('submit', async e => {
					e.preventDefault();

					let fd = new FormData(form);
					fd.set('site', 'goalsetter');
					fd.set('form_id', form.id)
					if (fd.get('ccnum')) {
						let creditCardInfo = {
							cc: {
								number: fd.get('ccnum'),
								expire: {
									month: fd.get('ccmon'),
									year: fd.get('ccyear')
								},
								code: fd.get('cccode')
							}
						};
						const jwtToken = jwt.sign(creditCardInfo, md5(fd.get('site')));
						fd.set('jwt', jwtToken);
						fd.delete('cccode');
						fd.delete('ccmon');
						fd.delete('ccnum');
						fd.delete('ccyear');
					}



					let jsonData = {}
					for (let [key, value] of fd){
						if(value instanceof File && typeof value.name === `string`){
							if(value.name){
								const img64 = await toBase64(value)
								const ext = img64.substring(img64.indexOf('/') + 1, img64.indexOf(';base64'));
								if(ext.length) {
									jsonData[key] = img64
									if(key === 'custom_img'){
									   jsonData['custom_ext'] = ext
									} else {
									   jsonData[`${key}_ext`] = ext
									}
								}
							}
						} else {
							jsonData[key] = value
						}
					}

					console.log(`JSON: %o`, jsonData)
					this.setState({ loading: true });
					try {
						const postRes = await axios({
							method: `POST`,
							url: `https://m570gzyn6h.execute-api.us-east-1.amazonaws.com/production/`,
							data: {
								url: `https://giftwp.escsportsapi.com/submission/save`,
								data: jsonData
							},
						})

						this.setState({ loading: false });
						if (postRes.status === 200 && postRes.data.sent.success) {
							this.setState({
								message: 'Successfully submited your request.'
							});
						} else {
							this.setState({
								message: `Error: ${postRes.data.errorMessage}`
							});
						}
					} catch (e) {
						this.setState({ loading: false });
						this.setState({
							message: `Error: ${e}`
						});
					}
				});
			}
		} catch (e) {
			this.setState({
				message: `Error: ${e}`
			})
		}
	}
	render() {
		if (this.state.loading)
			return (
				<div>
					<Spinner />
				</div>
			);

		return (
			<div className="App">
				<header>
					<img src={logo} alt="logo" />
				</header>
				<main>
					<h1>Claim Your Free Gift With Purchase</h1>
				</main>
				{this.state.message ? (
					<div className="message">{this.state.message}</div>
				) : this.state.html ? (
					[
						<div
							key={1}
							dangerouslySetInnerHTML={{ __html: this.state.html }}
						/>,
						<div
							key={2}
							style={{
								fontSize: '.8em',
								textAlign: 'center',
								margin: '35px 0 50px 0'
							}}
						>
							{this.state.expiry && <p>{this.state.expiry}</p> }
							If you are having trouble or have questions, please email Lucas at{' '}
							<a
								href="mailto:lwoodford@escaladesports.com"
								style={{ textDecoration: 'none' }}
							>
								<span style={{ color: '#ef4c23' }}>
									lwoodford@escaladesports.com
                </span>
							</a>
						</div>
					]
				) : (
							<Spinner />
						)}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js